import './App.css';
import { WeatherApp } from './weatherapp/weatherapp';
import { useEffect, useState } from 'react';
// import  weatherapp from "./";

function App() {

  const [weather, setWeather] = useState({});

  useEffect(() => {
    const fetchWeather = async () => {
      const api_key = 'e5604f1af448e04858452ef3c3e9d46b';
      const city = 'YourCity'; // Replace with the desired city
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=Metric&appid=${api_key}`;

      try {
        const response = await fetch(url);
        const data = await response.json();
        setWeather(data);
      } catch (error) {
        console.error('Error fetching weather data:', error);
      }
    };

    fetchWeather();
  }, []);
  return (
    <div className={( () => {
      return weather.main && weather.main.temp < 6 ? 'App snow' : 'App autumn';
    })()}>
      <WeatherApp />
    </div>
  );
}

export default App;
